import { SET_TRANSFER, CLEAR_TRANSFER, SET_IS_CONFIRM_RECEIVER_DETAIL } from '../actions/actionTypes';
import { TransferAction } from '../actions/transfer';
import { LocationAttribute } from '../api/location';

export type TransferReducer = {
    active_field: string;
    destination_amount: string;
    amount: string;
    fee: number;
    exchange_rate: number;
    receiver: string;
    receiver_id: string;
    receiver_mobile_number: string;
    receiver_firstname_en: string;
    receiver_lastname_en: string;
    receiver_national_id: string;
    receiver_street_address: string;
    receiver_state_id: string;
    receiver_township_id: string;
    receiver_city_id: string;
    receiver_state_name: string | LocationAttribute[];
    receiver_township_name: string | LocationAttribute[];
    receiver_city_name: string | LocationAttribute[];
    receiver_nid_region: string;
    receiver_nid_township: string;
    receiver_nid_type: string;
    receiver_nid_personal_id: string;
    receiver_address: string;
    purpose: {
        id: string;
        name: string;
        sequence: number;
        message: string;
    };
    isConfirmReceiverDetail: boolean;
};

export type TransferReducerState = {
    transfer: TransferReducer;
};

const intialState: TransferReducer = {
    active_field: '',
    destination_amount: '',
    amount: '',
    fee: 0,
    exchange_rate: 0,
    receiver: '',
    receiver_id: '',
    receiver_mobile_number: '',
    receiver_firstname_en: '',
    receiver_lastname_en: '',
    receiver_national_id: '',
    receiver_street_address: '',
    receiver_state_id: '',
    receiver_township_id: '',
    receiver_city_id: '',
    receiver_state_name: '',
    receiver_township_name: '',
    receiver_city_name: '',
    receiver_nid_region: '',
    receiver_nid_township: '',
    receiver_nid_type: '',
    receiver_nid_personal_id: '',
    purpose: {
        id: '',
        name: '',
        sequence: 0,
        message: '',
    },
    isConfirmReceiverDetail: false,
    receiver_address: '',
};

const transfer = (state = intialState, action: TransferAction): TransferReducer => {
    switch (action.type) {
        case SET_TRANSFER:
            return {
                ...state,
                ...action.payload,
            };
        case CLEAR_TRANSFER:
            return intialState;
        case SET_IS_CONFIRM_RECEIVER_DETAIL:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default transfer;
